// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonLaserPointerColored_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18.8661 2.10732L17.5732 4.34681L20.0712 3.67747L20.5888 5.60932L18.091 6.27861L20.3302 7.57142L19.3302 9.30347L17.0908 8.01051L17.76 10.5082L15.8282 11.0258L15.159 8.52835L11.8661 14.2317L10.1341 13.2317L13.4272 7.52793L10.9294 8.19719L10.4118 6.26534L12.9091 5.5962L10.67 4.30347L11.67 2.57142L13.9096 3.86448L13.2404 1.36676L15.1722 0.849121L15.8414 3.34639L17.1341 1.10732L18.8661 2.10732Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5979 13.5L9.40173 10.5L3.40173 20.8923L8.59789 23.8923L14.5979 13.5ZM11.8658 14.2321L10.1338 13.2321L9.00795 15.182L10.74 16.182L11.8658 14.2321Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonLaserPointerColored is a generated icon component.
 */
let IconCommonLaserPointerColored = IconCommonLaserPointerColored_1 = class IconCommonLaserPointerColored extends IconBaseElement {
    render() {
        return html `${IconCommonLaserPointerColored_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonLaserPointerColored.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonLaserPointerColored = IconCommonLaserPointerColored_1 = __decorate([
    customElement('zui-icon-common-laser-pointer-colored')
], IconCommonLaserPointerColored);
export { IconCommonLaserPointerColored };
